"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FieldBox_1 = require("../../../FieldBox");
const ScrollbarThumb = (palette) => (props) => ((0, jsx_runtime_1.jsx)("div", { ...props, style: {
        borderRadius: '4px',
        background: palette === FieldBox_1.FieldBoxPalette.Dark
            ? ' rgba(245, 247, 250, 0.2)'
            : 'rgb(193, 193, 193)',
    } }));
exports.default = ScrollbarThumb;
